var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTemplateHelper = function SvgTemplateHelper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "template_helper_svg2__a",
    x1: -85.46,
    x2: 143.69,
    y1: 138.92,
    y2: -44.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_helper_svg2__a",
    id: "template_helper_svg2__c",
    x1: -86.18,
    x2: 142.97,
    y1: 138.02,
    y2: -45.31
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_helper_svg2__a",
    id: "template_helper_svg2__d",
    x1: -58.72,
    x2: 170.43,
    y1: 172.34,
    y2: -10.98
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_helper_svg2__a",
    id: "template_helper_svg2__e",
    x1: -53.78,
    x2: 175.37,
    y1: 178.51,
    y2: -4.81
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_helper_svg2__a",
    id: "template_helper_svg2__f",
    x1: -50.29,
    x2: 178.87,
    y1: 182.88,
    y2: -0.44
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_helper_svg2__a",
    id: "template_helper_svg2__g",
    x1: -51.01,
    x2: 178.14,
    y1: 181.98,
    y2: -1.34
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_helper_svg2__a",
    id: "template_helper_svg2__h",
    x1: -23.55,
    x2: 205.6,
    y1: 216.31,
    y2: 32.98
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_helper_svg2__a",
    id: "template_helper_svg2__i",
    x1: -18.61,
    x2: 210.54,
    y1: 222.48,
    y2: 39.16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_helper_svg2__a",
    id: "template_helper_svg2__j",
    x1: -15.12,
    x2: 214.04,
    y1: 226.85,
    y2: 43.52
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_helper_svg2__a",
    id: "template_helper_svg2__k",
    x1: -15.84,
    x2: 213.31,
    y1: 225.94,
    y2: 42.62
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_helper_svg2__a",
    id: "template_helper_svg2__l",
    x1: 11.62,
    x2: 240.77,
    y1: 260.27,
    y2: 76.95
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#template_helper_svg2__a",
    id: "template_helper_svg2__m",
    x1: 16.56,
    x2: 245.71,
    y1: 266.44,
    y2: 83.12
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M53.31 0C37.92 0 25.39 12.52 25.39 27.92S37.91 55.8 53.31 55.8s27.92-12.51 27.92-27.88S68.71 0 53.31 0m0 49.55c-11.95 0-21.67-9.7-21.67-21.63 0-11.95 9.72-21.67 21.67-21.67s21.67 9.72 21.67 21.67-9.72 21.63-21.67 21.63",
    style: {
      fill: "url(#template_helper_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.68 19.77-9.63 9.63-3.11-3.11a3.126 3.126 0 0 0-4.42 4.42l5.32 5.32a3.12 3.12 0 0 0 4.42 0L64.1 24.19a3.126 3.126 0 0 0-4.42-4.42",
    style: {
      fill: "url(#template_helper_svg2__c)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.71 20.81h73.77c1.73 0 3.13-1.4 3.13-3.13s-1.4-3.13-3.13-3.13H97.71c-1.73 0-3.13 1.4-3.13 3.13s1.4 3.13 3.13 3.13",
    style: {
      fill: "url(#template_helper_svg2__d)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.71 41.24h48.03c1.73 0 3.13-1.4 3.13-3.13s-1.4-3.13-3.13-3.13H97.71c-1.73 0-3.13 1.4-3.13 3.13s1.4 3.13 3.13 3.13",
    style: {
      fill: "url(#template_helper_svg2__e)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.31 72.1c-15.39 0-27.92 12.52-27.92 27.92 0 15.37 12.52 27.88 27.92 27.88s27.92-12.51 27.92-27.88S68.71 72.1 53.31 72.1m0 49.55c-11.95 0-21.67-9.7-21.67-21.63 0-11.95 9.72-21.67 21.67-21.67s21.67 9.72 21.67 21.67-9.72 21.63-21.67 21.63",
    style: {
      fill: "url(#template_helper_svg2__f)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.68 91.87-9.63 9.63-3.11-3.11a3.126 3.126 0 0 0-4.42 4.42l5.32 5.32c.61.61 1.41.92 2.21.92s1.6-.31 2.21-.92L64.1 96.29a3.126 3.126 0 0 0-4.42-4.42",
    style: {
      fill: "url(#template_helper_svg2__g)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.48 86.66H97.71c-1.73 0-3.13 1.4-3.13 3.13s1.4 3.13 3.13 3.13h73.77c1.73 0 3.13-1.4 3.13-3.13s-1.4-3.13-3.13-3.13",
    style: {
      fill: "url(#template_helper_svg2__h)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.71 113.34h48.03c1.73 0 3.13-1.4 3.13-3.13s-1.4-3.13-3.13-3.13H97.71c-1.73 0-3.13 1.4-3.13 3.13s1.4 3.13 3.13 3.13",
    style: {
      fill: "url(#template_helper_svg2__i)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.31 144.2c-15.39 0-27.92 12.52-27.92 27.92 0 15.37 12.52 27.88 27.92 27.88s27.92-12.51 27.92-27.88-12.52-27.92-27.92-27.92m0 49.55c-11.95 0-21.67-9.7-21.67-21.63 0-11.95 9.72-21.67 21.67-21.67s21.67 9.72 21.67 21.67-9.72 21.63-21.67 21.63",
    style: {
      fill: "url(#template_helper_svg2__j)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.68 163.97-9.63 9.63-3.11-3.11a3.126 3.126 0 0 0-4.42 4.42l5.32 5.32c.61.61 1.41.92 2.21.92s1.6-.31 2.21-.92l11.84-11.84a3.126 3.126 0 0 0-4.42-4.42",
    style: {
      fill: "url(#template_helper_svg2__k)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.48 158.76H97.71c-1.73 0-3.13 1.4-3.13 3.13s1.4 3.13 3.13 3.13h73.77c1.73 0 3.13-1.4 3.13-3.13s-1.4-3.13-3.13-3.13",
    style: {
      fill: "url(#template_helper_svg2__l)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.74 179.19H97.71c-1.73 0-3.13 1.4-3.13 3.13s1.4 3.13 3.13 3.13h48.03c1.73 0 3.13-1.4 3.13-3.13s-1.4-3.13-3.13-3.13",
    style: {
      fill: "url(#template_helper_svg2__m)",
      strokeWidth: 0
    }
  }));
};
export default SvgTemplateHelper;